export function sortByCreated<T extends { created_at?: string }>(a: T, b: T) {
  if (!a.created_at && !b.created_at) {
    return 0;
  }

  if (!a.created_at) {
    return 1;
  }

  if (!b.created_at) {
    return -1;
  }

  return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
}
